import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { getExpedientStatus, startExpedient } from '../../store/ducks/humanResources'
import Navbar from './Navbar'
import Header from './Header'
/* import Footer from './Footer' */

class Layout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isMenuOpened: false,
    }
  }

  componentDidMount() {
    const { getExpedientStatus } = this.props

    getExpedientStatus()
  }

  // eslint-disable-next-line react/no-access-state-in-setstate
  openMenu = () => this.setState({ isMenuOpened: !this.state.isMenuOpened })

  render() {
    return (
      <div id="layout-wrapper">
        <Header
          theme={this.props.topbarTheme}
          isMenuOpened={this.state.isMenuOpened}
          openLeftMenuCallBack={this.openMenu}
        />
        <Navbar menuOpen={this.state.isMenuOpened} />
        <div className="main-content">
          {this.props.children}
          {/* <Footer /> */}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({ humanResources: state.humanResources })
const mapDispatchToProps = dispatch => bindActionCreators({
  getExpedientStatus,
  startExpedient,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Layout)
